import React from 'react';
import WalletHeader from './WalletHeader';
import BalanceSection from './BalanceSection';
import TokensList from './TokensList';
import styles from '@/styles/components/wallet/ConnectedWalletView.module.css';

const ConnectedWalletView: React.FC = () => {
  return (
    <div className={styles.walletCard}>
      <div className={styles.walletHeader}>
        {/* Wallet Header */}
        <WalletHeader />
      </div>

      {/* Balance Section */}
      <BalanceSection />

      {/* Tokens Section */}
      <TokensList />
    </div>
  );
};

export default ConnectedWalletView;